import { colors } from '@lmc/common/constants'
import { EmarModuleCard, FamilyPlanModuleCard, IconType } from '@lmc/ui-kit'
import { colours } from '@lmc/ui-kit/src/config/theme'
import type React from 'react'
import { PaywallTemplateWrapper } from '../../../../../../components/generic/PaywallTemplateWrapper'

interface StateProps {
  testId?: string
  preferredPeopleNominative?: string
}

const ConsentPaywallComponent: React.FC<StateProps> = ({
  testId,
  preferredPeopleNominative
}) => {
  return (
    <PaywallTemplateWrapper
      backgroundColor={colours.status.popout}
      title="Consent management"
      subTitle={`Our customisable consent forms including vaccinations and finances can be digitally signed by ${preferredPeopleNominative || 'service users'} or their LPA to confirm agreement with outlined steps.`}
      bodyText="Easily manage your clients' consent forms in one place."
      icon={IconType.ConsentHexagon}
      videoUrl="https://www.youtube.com/embed/H0Y6jXJL_ak"
      testId={testId}
      articles={[
        {
          title: 'How do I sign consent forms?',
          subtitle: 'View Article',
          icon: 'SettingOutlined',
          id: 'testId1',
          link: 'https://support.logmycare.co.uk/en/articles/6014548-how-do-i-add-and-sign-consent-and-lack-of-capacity-forms',
          iconBackgroundColour: colors.orange,
          iconColour: colors.white
        },
        {
          title: 'How do I edit consent forms?',
          subtitle: 'View Article',
          icon: 'QuestionCircleOutlined',
          id: 'testId2',
          link: 'https://support.logmycare.co.uk/en/articles/6041191-how-do-i-edit-consent-or-lack-of-capacity-forms',
          iconBackgroundColour: colors.green,
          iconColour: colors.white
        },
        {
          title: 'What other features do I get with Pro?',
          subtitle: 'View Article',
          icon: 'UserOutlined',
          id: 'testId3',
          link: 'https://support.logmycare.co.uk/en/collections/1681220-the-pro-plan',
          iconBackgroundColour: colors.purple,
          iconColour: colors.white
        }
      ]}
      leftModuleCard={<EmarModuleCard />}
      rightModuleCard={<FamilyPlanModuleCard />}
      findOutMoreURL="https://logmycare.co.uk/features/care-delivery"
      customLinkText="Read more"
    />
  )
}

export const ConsentPaywall = ConsentPaywallComponent
